import React, { useCallback } from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import { isSupplierUrlContext } from '../../utils/AnalyticsComparisonUtils';
import { OVERALL_ROW_KEY } from './LifeCycleAnalyticsConstants';

type PriorityCard = {
	woPriorityId: number | string;
	woPriorityName: string;
	completedWoCount: number;
	color: string;
	bgColor: string;
};

type PriorityCardScrollerProps = {
	cards: PriorityCard[];
	selectedPriorityId: number | string | null;
	onCardClick: (priorityId: number | string) => void;
};

const PriorityCardScroller = ({
	cards,
	selectedPriorityId,
	onCardClick,
}: PriorityCardScrollerProps) => {
	const handleCardClick = useCallback(
		(event: React.MouseEvent<HTMLButtonElement>) => {
			const raw = event.currentTarget.dataset.priorityId || '';
			if (raw === OVERALL_ROW_KEY) {
				onCardClick(OVERALL_ROW_KEY);
				return;
			}
			const priorityId = parseInt(raw, 10);
			if (Number.isNaN(priorityId)) return;
			onCardClick(priorityId);
		},
		[onCardClick]
	);

	return (
		<div className="mt-3 flex flex-wrap gap-s py-px">
			{cards.map((card) => {
				const isSelected = card.woPriorityId === selectedPriorityId;
				return (
					<button
						key={card.woPriorityId}
						type="button"
						data-priority-id={card.woPriorityId}
						aria-pressed={isSelected}
						onClick={handleCardClick}
						className={`flex h-[82px] min-w-0 max-w-[260px] flex-1 basis-[200px] cursor-pointer flex-col items-start overflow-hidden rounded-[4px] border border-solid border-grey-5 p-s text-left transition-colors ${
							isSelected ? (isSupplierUrlContext() ? 'bg-cyan-6' : 'bg-purple-6') : 'bg-grey-1'
						}`}
					>
						<div className="inline-block min-w-0 max-w-full align-middle">
							<AntdTooltip title={card.woPriorityName}>
								<span
									className={`bodymedium inline-block min-w-0 max-w-full truncate px-3 py-0.5 ${
										isSelected ? 'text-white' : 'rounded-[24px]'
									}`}
									style={
										isSelected
											? undefined
											: {
													color: card.color,
													backgroundColor: card.bgColor,
											  }
									}
								>
									{card.woPriorityName}
								</span>
							</AntdTooltip>
						</div>
						<div className="px-3">
							<span className={`h5medium ${isSelected ? 'text-white' : 'text-character-primary'}`}>
								{card.completedWoCount}
							</span>{' '}
							<span
								className={`bodyregular ${
									!isSelected ? 'text-character-secondary' : 'text-grey-1'
								}`}
							>
								WOs
							</span>
						</div>
					</button>
				);
			})}
		</div>
	);
};

export default PriorityCardScroller;
